import http from "./index";

export default {

  // login(e) {  //登录
  //   return http.post("auth/login", e, false);
  // },
  getNews(e) {  //获取新闻列表
    return http.get('/jiwate/news/page', e, false)
  },
  getrecentNews(e) {  //获取最近一条新闻数据
    return http.get('/jiwate/news/current', e, false)
  },
  getVerificationCode(e) {  //生成验证码
    return http.get('/jiwate/captcha', e, false)
  },
  getNewsHotspot(e) {  //获取最近一条新闻数据
    return http.get('/jiwate/news/hotspot/', e, false)
  },
  getProduct(e) {  //获取产品列表
    return http.get(`/jiwate/product`, e, false)
  },
  getContactUs(e) {  //联系我们
    return http.post('/jiwate/message', e, false)
  },
  getsupport(e) {  //支持中心
    return http.get('/jiwate/manual', e, false)
  },
  gethomeproduct(e) {  //首页产品列表
    return http.get('/jiwate/product/homepage', e, false)
  },
  gethomenews(e) {  //首页新闻列表
    return http.get('/jiwate/news/homepage', e, false)
  },
  getproductdetails(e) {  //产品详情
    return http.geta('/jiwate/product', e, false)
  },
  getcertificate(e) {      //证书列表 
    return http.get('/jiwate/certificate', e, false)
  },
  getabout(e) {      //关于吉瓦特
    return http.get('/jiwate/documents', e, false)
  },
  getnewsdetails(e) {  //新闻详情
    return http.geta('/jiwate/news/detail', e, false)
  },
};
